import React from "react"
import clsx from "clsx"
import { MagnifyingGlassIcon } from "@phosphor-icons/react"

const SearchButton = ({ 
	className = '',
	onClick,
	showInputField,
}) => {
	return (
		<button
			className={clsx("relative flex items-center py-2.5 justify-between text-secondary gap-x-4", className, showInputField && 'w-full')}
			onClick={onClick}
			aria-label="Search"
		>
			<MagnifyingGlassIcon
				className={clsx("menu-icons cursor-pointer text-black", showInputField && 'absolute z-[1] ml-4')}
				weight="light"
			/>
			{showInputField && (
				<div className="relative w-full">
					<div
						className="rounded-full bg-[#E7E7E7] w-full h-8 z-0"
						type="text"
					/>
				</div>
			)}
		</button>
	)
}

export default SearchButton